import { Box, Paper, Typography, useTheme } from "@mui/material";
import logoGreen from "../assets/images/logo_smaart_green.png";
import InitialPasswordChangeForm from "../components/forms/initialPasswordChangeForm.component";
import {
  authLogoStyles,
  authPageContainerStyles,
  authPaperStyles,
  authTitleStyles,
} from "../styles/commonStyles";

const InitialPasswordChangePage = () => {
  const theme = useTheme();
  return (
    <Box sx={authPageContainerStyles(theme)}>
      <Paper sx={authPaperStyles}>
        <Box sx={authTitleStyles}>CAMBIO PASSWORD</Box>
        <Box
          component="img"
          src={logoGreen}
          alt="Smaart Logo"
          sx={authLogoStyles}
        />
        <Box sx={{ width: "100%" }}>
          <Typography fontWeight={400} fontSize="12px">
            Scegli la tua nuova password per accedere al portale
          </Typography>
        </Box>
        <InitialPasswordChangeForm />
      </Paper>
    </Box>
  );
};

export default InitialPasswordChangePage;
